/* eslint-disable global-require */
module.exports = ['component.store.stats.index.m1', 'marketplace.stores.edit.form.m1'];
